(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["display"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class DisplaySection {
      constructor(root) {
        this.root = root;
        this.slots = Array.from(root.querySelectorAll('[data-display-slot]'));
        this.rafId = null;
        this.scrollIntensity = Number(root.dataset.scrollIntensity || 1);
        this.scrollDelay = Number(root.dataset.scrollDelay || 0.5);
        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.update = this.update.bind(this);
        this.init();
      }

      init() {
        if (this.root.dataset.initialized === 'true') return;
        this.root.dataset.initialized = 'true';

        if (this.slots.length < 2) {
          this.root.classList.add('is-ready');
          return;
        }

        requestAnimationFrame(() => {
          this.root.classList.add('is-ready');
        });

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize, { passive: true });
        this.mobileQuery.addEventListener('change', this.handleResize);
        this.fitHeaderText();
        this.update();
      }

      handleScroll() {
        if (this.rafId) return;
        this.rafId = window.requestAnimationFrame(this.update);
      }

      handleResize() {
        this.fitHeaderText();
        this.handleScroll();
      }

      clamp(value, min = 0, max = 1) {
        return Math.min(max, Math.max(min, value));
      }

      fitHeaderText() {
        if (!this.mobileQuery.matches) return;
        const headerText = this.root.querySelector('.display-section__header-text');
        if (!headerText) return;

        // Must match left/right values in the mobile CSS media query above
        const sidePadding = 2;
        const availableWidth = window.innerWidth - (sidePadding * 2);

        // Use a measurement clone to find the ideal font size
        const clone = headerText.cloneNode(true);
        clone.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;font-size:10px;line-height:1.1;letter-spacing:inherit;font-family:inherit;';
        document.body.appendChild(clone);

        // Binary search for the largest font size that fits
        let lo = 8;
        let hi = 200;
        while (lo < hi) {
          const mid = Math.ceil((lo + hi + 1) / 2);
          clone.style.fontSize = mid + 'px';
          if (clone.scrollWidth <= availableWidth) {
            lo = mid;
          } else {
            hi = mid - 1;
          }
        }

        document.body.removeChild(clone);
        this.root.style.setProperty('--display-header-font-size-mobile', lo + 'px');
      }

      update() {
        this.rafId = null;

        const isMobile = this.mobileQuery.matches;
        const viewportHeight = window.innerHeight;
        const scrollDistance = viewportHeight * 2 / this.scrollIntensity;
        const sectionRect = this.root.getBoundingClientRect();
        const sectionScroll = Math.max(-sectionRect.top, 0);

        this.slots.forEach((slot, index) => {
          const stageInner = slot.querySelector('[data-display-stage-inner]');
          const panes = slot.querySelectorAll('[data-display-pane]');

          if (!stageInner || panes.length < 2) return;

          if (!isMobile) {
            if (index === 0) {
              panes[0].style.transform = 'none';
              panes[1].style.transform = 'none';
              stageInner.style.transform = 'none';
              return;
            }

            const transitionStart = (index - 1) * scrollDistance;
            const triggered = sectionScroll > transitionStart + 1;

            panes[0].style.transform = triggered ? 'none' : 'translateY(100%)';

            const bOffset = this.scrollDelay * scrollDistance;
            const bTriggered = sectionScroll > transitionStart + bOffset + 1;
            panes[1].style.transform = bTriggered ? 'none' : 'translateY(100%)';

            stageInner.style.transform = 'none';
            return;
          }

          if (index === 0) {
            panes[0].style.transform = 'none';
          } else {
            const aStart = index * 2 * scrollDistance;
            const aTriggered = sectionScroll > aStart + 1;
            panes[0].style.transform = aTriggered ? 'none' : 'translateY(100%)';
          }

          const bStep = index === 0 ? 0.1 : (index * 2 + 1);
          const bStart = bStep * scrollDistance;
          const bTriggered = sectionScroll > bStart + 1;
          panes[1].style.transform = bTriggered ? 'none' : 'translateY(100%)';

          stageInner.style.transform = 'none';
        });
      }
    }

    const boot = () => {
      document.querySelectorAll('[data-display-section]').forEach((root) => {
        if (root.__displaySectionInstance) return;
        root.__displaySectionInstance = new DisplaySection(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-footer"] && !Shopify.designMode) return;
  try {
    
  class HeroFooter {
    constructor(element) {
      this.element = element;
      this.container = element.querySelector('.hero-footer-container');
      this.entranceDelay = parseFloat(element.dataset.entranceDelay) * 1000 || 0;
      this.entranceDuration = parseFloat(element.dataset.entranceDuration) * 1000 || 1000;
      
      // Set CSS variables for animation timing
      this.container.style.setProperty('--entrance-duration', `${this.entranceDuration}ms`);
      this.container.style.setProperty('--entrance-delay', `${this.entranceDelay}ms`);
      
      this.init();
    }

    init() {
      // Check if scrolling is complete by looking for scroll images visibility
      const scrollContainers = document.querySelectorAll('.hero-scroll-images-container');
      
      if (scrollContainers.length > 0) {
        // If scroll images exist, trigger animation when they're done
        this.waitForScrollCompletion();
      } else {
        // If no scroll images, use delay-based triggering
        this.triggerAnimation();
      }
    }

    waitForScrollCompletion() {
      // Poll for when all scroll images have been viewed
      const checkInterval = setInterval(() => {
        const scrollLeft = document.querySelector('.hero-scroll-left');
        const scrollRight = document.querySelector('.hero-scroll-right');
        
        // Check if both containers have scrolled through all images
        if (scrollLeft && scrollRight) {
          const leftImages = scrollLeft.querySelectorAll('.hero-scroll-image').length;
          const rightImages = scrollRight.querySelectorAll('.hero-scroll-image').length;
          
          // Get scroll progress (this would need coordination with hero section)
          const leftProgress = Math.abs(parseInt(scrollLeft.style.transform.match(/translateY\(-([\d.]+)%\)/)?.[1] || 0));
          const rightProgress = Math.abs(parseInt(scrollRight.style.transform.match(/translateY\(-([\d.]+)%\)/)?.[1] || 0));
          
          // If we've scrolled past 90% of images, trigger footer
          if (leftProgress > 85 && rightProgress > 85) {
            clearInterval(checkInterval);
            this.triggerAnimation();
          }
        }
      }, 100);
      
      // Safety timeout after 10 seconds
      setTimeout(() => {
        clearInterval(checkInterval);
        if (!this.animationTriggered) {
          this.triggerAnimation();
        }
      }, 10000);
    }

    triggerAnimation() {
      this.animationTriggered = true;
      this.container.style.animation = `footerEntranceSlide ${this.entranceDuration}ms ease-out ${this.entranceDelay}ms forwards`;
    }
  }

  const initHeroFooterSections = () => {
    document.querySelectorAll('[data-hero-footer-section]').forEach((sectionElement) => {
      if (sectionElement.dataset.heroFooterInitialized === 'true') {
        return;
      }

      sectionElement.dataset.heroFooterInitialized = 'true';
      new HeroFooter(sectionElement);
    });
  };

  initHeroFooterSections();

  document.addEventListener('shopify:section:load', initHeroFooterSections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-two-column"] && !Shopify.designMode) return;
  try {
    
  class HeroTwoColumn {
    constructor(element) {
      this.container = element;
      this.scrollLeftContainer = element.querySelector('.hero-scroll-left');
      this.scrollRightContainer = element.querySelector('.hero-scroll-right');
      this.currentIndexLeft = 0;
      this.currentIndexRight = 0;
      this.isScrolling = false;
      this.canScroll = true; // New: blocks scroll during delay
      this.scrollImagesActive = false;
      this.queuedSteps = 0;
      this.hasCompleted = false;
      this.scrollDelay = 200; // ms delay between left and right
      this.scrollDuration = 800; // ms for image to slide up (reduced from 1000)
      this.stickyDelay = 1000; // 1 second sticky delay before next image can appear
      this.isOnMobile = window.innerWidth < 750;
      this.scrollAccumulator = 0;
      this.wheelSensitivity = 180; // pixels of wheel scroll to trigger next image
      
      this.init();
    }

    init() {
      // On mobile, disable scroll hijacking to allow natural page scroll
      if (this.isOnMobile) {
        // On mobile: setup touch handlers for scrolling within the hero
        if (this.scrollLeftContainer && this.scrollRightContainer) {
          this.bindTouchHandlers();
        }
        return;
      }

      if (!this.scrollLeftContainer || !this.scrollRightContainer) {
        // don't exit entirely — scrolling behaviour is disabled, but keep menu handlers
        return; // Scrolling not enabled
      }

      // Add body class to pin page while hero is scrolling
      document.body.style.overflow = 'hidden';
      
      // Use wheel event instead of window scroll
      window.addEventListener('wheel', (e) => this.handleWheel(e), { passive: false });
      window.addEventListener('resize', () => this.handleResize());
      
      // Pre-calculate image counts
      this.leftImages = Array.from(this.scrollLeftContainer.querySelectorAll('.hero-scroll-image'));
      this.rightImages = Array.from(this.scrollRightContainer.querySelectorAll('.hero-scroll-image'));
      this.imageCountLeft = this.leftImages.length;
      this.imageCountRight = this.rightImages.length;
      this.maxIndex = Math.min(this.imageCountLeft, this.imageCountRight) - 1;
      
      // Initialize scroll position - keep scroll images hidden until first scroll
      this.updateScrollPosition();
    }

    handleWheel(e) {
      // Block scrolling if already scrolling or during delay period
      if (this.isScrolling || !this.canScroll) {
        e.preventDefault();
        if (e.deltaY !== 0) {
          this.queuedSteps += e.deltaY > 0 ? 1 : -1;
        }
        return;
      }
      
      if (this.currentIndexLeft >= this.maxIndex && this.currentIndexRight >= this.maxIndex) {
        return;
      }

      e.preventDefault();
      this.scrollAccumulator += e.deltaY;

      if (Math.abs(this.scrollAccumulator) >= this.wheelSensitivity) {
        const direction = this.scrollAccumulator > 0 ? 1 : -1;

        if (!this.scrollImagesActive) {
          if (direction > 0 && this.maxIndex >= 0) {
            this.activateScrollImages();
            this.scrollToIndex(0);
          }
          this.scrollAccumulator = 0;
          return;
        }

        const nextIndex = Math.max(0, Math.min(
          this.maxIndex,
          this.currentIndexLeft + direction
        ));

        if (nextIndex !== this.currentIndexLeft) {
          this.scrollToIndex(nextIndex);
          this.scrollAccumulator = 0;
        }
      }
    }

    scrollToIndex(targetIndex) {
      this.isScrolling = true;
      this.canScroll = false; // Block new scrolls during animation + delay
      
      // Scroll left column
      this.animateScroll(this.leftImages, targetIndex, 0);
      
      // Scroll right column with delay
      this.animateScroll(this.rightImages, targetIndex, this.scrollDelay);
      
      this.currentIndexLeft = targetIndex;
      this.currentIndexRight = targetIndex;

      // Total time: scroll + sticky delay
      // After this, allow scrolling again
      const totalDuration = this.scrollDuration + this.stickyDelay + this.scrollDelay;
      setTimeout(() => {
        this.isScrolling = false;
        this.canScroll = true; // Allow scrolling after delay completes
        if (this.queuedSteps !== 0) {
          const direction = this.queuedSteps > 0 ? 1 : -1;
          this.queuedSteps -= direction;
          const nextIndex = Math.max(0, Math.min(
            this.maxIndex,
            this.currentIndexLeft + direction
          ));

          if (nextIndex !== this.currentIndexLeft) {
            this.scrollToIndex(nextIndex);
          }
        }
      }, totalDuration);
    }

    animateScroll(images, targetIndex, delay) {
      const targetImage = images[targetIndex];
      if (!targetImage) return;

      // Phase 1: Slide next image up over the previous one
      setTimeout(() => {
        targetImage.style.transition = `transform ${this.scrollDuration}ms cubic-bezier(0.25, 0.46, 0.45, 0.94)`;
        targetImage.style.transform = 'translateY(0)';
        targetImage.style.opacity = '1';
      }, delay);

      // Phase 2: Remove transition so it sticks during delay
      setTimeout(() => {
        targetImage.style.transition = 'none';
      }, delay + this.scrollDuration);
    }

    activateScrollImages() {
      if (this.scrollImagesActive) return;

      this.scrollImagesActive = true;

      if (this.scrollLeftContainer) {
        this.scrollLeftContainer.style.opacity = '1';
      }
      if (this.scrollRightContainer) {
        this.scrollRightContainer.style.opacity = '1';
      }
    }

    updateScrollPosition() {
      if (this.scrollLeftContainer) {
        this.scrollLeftContainer.style.opacity = this.scrollImagesActive ? '1' : '0';
      }
      if (this.scrollRightContainer) {
        this.scrollRightContainer.style.opacity = this.scrollImagesActive ? '1' : '0';
      }

      this.leftImages.forEach((image, index) => {
        image.style.transition = 'none';
        if (this.scrollImagesActive && index <= this.currentIndexLeft) {
          image.style.transform = 'translateY(0)';
          image.style.opacity = '1';
        } else {
          image.style.transform = 'translateY(100%)';
          image.style.opacity = '0';
        }
      });

      this.rightImages.forEach((image, index) => {
        image.style.transition = 'none';
        if (this.scrollImagesActive && index <= this.currentIndexRight) {
          image.style.transform = 'translateY(0)';
          image.style.opacity = '1';
        } else {
          image.style.transform = 'translateY(100%)';
          image.style.opacity = '0';
        }
      });
    }

    handleResize() {
      const wasMobile = this.isOnMobile;
      this.isOnMobile = window.innerWidth < 750;
      
      if (wasMobile !== this.isOnMobile) {
        this.currentIndexLeft = 0;
        this.currentIndexRight = 0;
        this.scrollImagesActive = false;
        this.updateScrollPosition();

        if (this.isOnMobile) {
          // switched to mobile: remove desktop wheel handler, add touch handlers
          if (this._onWheel) {
            window.removeEventListener('wheel', this._onWheel);
            this._onWheel = null;
          }
          this.bindTouchHandlers();
          document.body.style.overflow = 'hidden';
        } else {
          // switched to desktop: remove touch handlers, add wheel handler
          this.unbindTouchHandlers();
          this._onWheel = (e) => this.handleWheel(e);
          window.addEventListener('wheel', this._onWheel, { passive: false });
          document.body.style.overflow = 'hidden';
        }
      }
    }

    bindTouchHandlers() {
      this._onTouchStart = (e) => this.onTouchStart(e);
      this._onTouchMove = (e) => this.onTouchMove(e);
      this._onTouchEnd = (e) => this.onTouchEnd(e);
      this.container.addEventListener('touchstart', this._onTouchStart, { passive: false });
      this.container.addEventListener('touchmove', this._onTouchMove, { passive: false });
      this.container.addEventListener('touchend', this._onTouchEnd, { passive: false });
    }

    unbindTouchHandlers() {
      if (this._onTouchStart) this.container.removeEventListener('touchstart', this._onTouchStart);
      if (this._onTouchMove) this.container.removeEventListener('touchmove', this._onTouchMove);
      if (this._onTouchEnd) this.container.removeEventListener('touchend', this._onTouchEnd);
      this._onTouchStart = this._onTouchMove = this._onTouchEnd = null;
    }

    onTouchStart(e) {
      if (!e.touches || e.touches.length === 0) return;
      this.touchStartY = e.touches[0].clientY;
      this.touchAccumulator = 0;
      this.touchActive = true;
    }

    onTouchMove(e) {
      if (!this.touchActive || !e.touches || e.touches.length === 0) return;
      const y = e.touches[0].clientY;
      const delta = this.touchStartY - y;
      this.touchAccumulator += delta;
      this.touchStartY = y;

      // Prevent page scrolling while interacting with the hero
      e.preventDefault();

      if (Math.abs(this.touchAccumulator) >= this.wheelSensitivity) {
        const direction = this.touchAccumulator > 0 ? 1 : -1;

        if (!this.scrollImagesActive) {
          if (direction > 0 && this.maxIndex >= 0) {
            this.activateScrollImages();
            this.scrollToIndex(0);
          }
          this.touchAccumulator = 0;
          return;
        }

        const nextIndex = Math.max(0, Math.min(
          this.maxIndex,
          this.currentIndexLeft + direction
        ));

        if (nextIndex !== this.currentIndexLeft) {
          this.scrollToIndex(nextIndex);
        }

        this.touchAccumulator = 0;
      }
    }

    onTouchEnd() {
      this.touchActive = false;
      this.touchAccumulator = 0;
    }
  }

  const initHeroTwoColumnSections = () => {
    document.querySelectorAll('[data-hero-two-column-section]').forEach((sectionElement) => {
      if (sectionElement.dataset.heroTwoColumnInitialized === 'true') {
        return;
      }

      sectionElement.dataset.heroTwoColumnInitialized = 'true';
      new HeroTwoColumn(sectionElement);
    });
  };

  initHeroTwoColumnSections();

  document.addEventListener('shopify:section:load', initHeroTwoColumnSections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  class NewsletterEnvelope {
    constructor(element) {
      this.section = element;
      this.scrollArea = element.querySelector('.newsletter-scroll-area');
      this.envelopeBody = element.querySelector('.newsletter-envelope-body');
      this.flap = element.querySelector('.newsletter-envelope-flap');
      this.letter = element.querySelector('.newsletter-letter');
      this.scrollToRead = element.querySelector('.newsletter-scroll-to-read');
      this.letterContent = element.querySelector('.newsletter-letter-content');

      this.flapOpenAngle = parseFloat(element.dataset.flapOpenAngle) || 120;
      this.letterScaleStart = (parseFloat(element.dataset.letterScaleStart) || 25) / 100;
      this.letterVerticalOffset = parseFloat(element.dataset.letterVerticalOffset) || -50;
      this.scrollToReadMaxOpacity = parseFloat(element.dataset.scrollToReadOpacity) || 80;
      this.parallaxIntensity = (parseFloat(element.dataset.letterParallax) || 0) / 10;
      this.floatEnabled = element.dataset.floatEnabled === 'true';
      this.bounceEnabled = element.dataset.bounceEnabled === 'true';
      this.bounceIntensity = (parseFloat(element.dataset.bounceIntensity) || 30) / 100;
      this.opacityFade = element.dataset.envelopeOpacityFade === 'true';
      this.envelopeOpacity = parseFloat(element.dataset.envelopeOpacity) || 100;

      this.isMobile = window.matchMedia('(max-width: 749px)').matches;
      this.currentProgress = 0;
      this.letterExpanded = false;
      this.rafId = null;
      this.destroyed = false;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this._onScroll = this._onScroll.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onMobileChange = this._onMobileChange.bind(this);
      this._mobileHintTimer = null;

      this.init();
    }

    init() {
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.mobileQuery.addEventListener('change', this._onMobileChange);

      this._update(0);

      if (this.isMobile) {
        this._mobileHintTimer = setTimeout(() => {
          if (this.currentProgress < 0.05) {
            const hint = this.section.querySelector('.newsletter-mobile-hint');
            if (hint) hint.style.display = 'flex';
          }
        }, 2000);
      }

      this._initConfetti();
    }

    _onScroll() {
      if (this.destroyed || this.rafId) return;
      this.rafId = requestAnimationFrame(() => {
        this.rafId = null;
        this._calculateProgress();
      });
    }

    _onResize() {
      this._calculateProgress();
    }

    _onMobileChange(e) {
      this.isMobile = e.matches;
      this._calculateProgress();
    }

    _calculateProgress() {
      if (!this.scrollArea) return;
      const rect = this.scrollArea.getBoundingClientRect();
      const sectionHeight = rect.height;
      const viewportHeight = window.innerHeight;

      const scrollDistance = this.isMobile
        ? sectionHeight * 0.5
        : sectionHeight - viewportHeight;

      if (scrollDistance <= 0) {
        this._update(0);
        return;
      }

      const progress = Math.max(0, Math.min(1, -rect.top / scrollDistance));
      this.currentProgress = progress;
      this._update(progress);
    }

    _update(progress) {
      if (this.prefersReducedMotion) {
        this._updateReducedMotion(progress);
        return;
      }

      const envelopeOpenSpeed = this.isMobile ? 0.12 : 0.2;
      const envelopeProgress = Math.min(1, progress / envelopeOpenSpeed);

      const letterProgress = Math.max(0, Math.min(1, (progress - 0.1) / 0.9));

      // --- Flap rotation ---
      let flapAngle = envelopeProgress * this.flapOpenAngle;
      if (this.bounceEnabled && envelopeProgress >= 1) {
        const bouncePhase = Math.max(0, (progress - 0.2) / 0.06);
        if (bouncePhase <= 1) {
          flapAngle = this.flapOpenAngle + Math.sin(bouncePhase * Math.PI) * this.flapOpenAngle * this.bounceIntensity * 0.15;
        }
      }
      this.flap.style.transform = 'rotateX(' + flapAngle + 'deg) translateZ(1px)';

      // --- Envelope opacity ---
      if (this.opacityFade) {
        this.envelopeBody.style.opacity = String(envelopeProgress * (this.envelopeOpacity / 100));
      }

      // --- Letter scale & position ---
      const letterScale = this.letterScaleStart + (1 - this.letterScaleStart) * letterProgress;
      const parallaxOffset = this.parallaxIntensity * (1 - letterProgress) * 15;
      const ty = this.letterVerticalOffset * (1 - letterProgress) + parallaxOffset;
      this.letter.style.transform = 'translate3d(0,' + ty + 'px,0) scale3d(' + letterScale + ',' + letterScale + ',1)';

      // --- Scroll-to-read opacity ---
      if (this.scrollToRead) {
        let strOpacity = letterProgress < 0.7 ? 1 : Math.max(0, 1 - (letterProgress - 0.7) / 0.3);
        this.scrollToRead.style.opacity = String(strOpacity * (this.scrollToReadMaxOpacity / 100));
      }

      // --- Letter expanded state ---
      const isExpanded = letterProgress > 0.85;
      if (isExpanded !== this.letterExpanded) {
        this.letterExpanded = isExpanded;
        this.section.setAttribute('data-letter-expanded', String(isExpanded));
        if (this.letter) {
          this.letter.setAttribute('data-float', isExpanded && this.floatEnabled ? 'true' : 'false');
        }
      }

      // --- Hide mobile hint on any scroll ---
      if (progress > 0.02) {
        const hint = this.section.querySelector('.newsletter-mobile-hint');
        if (hint) hint.style.display = 'none';
      }
    }

    _initConfetti() {
      if (this.prefersReducedMotion) return;
      const successMsg = this.section.querySelector('.newsletter-form-message--success');
      if (!successMsg) return;

      const colors = [
        'var(--newsletter-email-btn-bg, #000)',
        'var(--newsletter-wax-seal-accent, #C9A84C)',
        '#e8f5e9',
        '#c8e6c9'
      ];

      for (let i = 0; i < 8; i++) {
        const particle = document.createElement('span');
        particle.className = 'newsletter-confetti-particle';
        particle.style.cssText = `
          position: absolute;
          width: ${4 + Math.random() * 4}px;
          height: ${4 + Math.random() * 4}px;
          background: ${colors[i % colors.length]};
          border-radius: ${Math.random() > 0.5 ? '50%' : '2px'};
          top: ${-10 - Math.random() * 10}px;
          left: ${10 + Math.random() * 80}%;
          opacity: 0;
          pointer-events: none;
          animation: newsletter-confetti-particle ${0.8 + Math.random() * 0.6}s ease-out ${0.1 + Math.random() * 0.4}s forwards;
        `;
        successMsg.appendChild(particle);
      }

      setTimeout(() => {
        this.section.querySelectorAll('.newsletter-confetti-particle').forEach(p => p.remove());
      }, 2000);
    }

    _updateReducedMotion(progress) {
      if (progress > 0.05) {
        this.flap.style.transform = 'rotateX(' + this.flapOpenAngle + 'deg) translateZ(1px)';
        if (this.opacityFade) this.envelopeBody.style.opacity = String(this.envelopeOpacity / 100);
      }
      if (progress > 0.1) {
        this.letter.style.transform = 'translate3d(0,0,0) scale3d(1,1,1)';
        this.section.setAttribute('data-letter-expanded', 'true');
        if (this.scrollToRead) this.scrollToRead.style.opacity = '0';
        if (this.letter) this.letter.setAttribute('data-float', 'false');
      }
    }

    destroy() {
      this.destroyed = true;
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      if (this.mobileQuery) {
        this.mobileQuery.removeEventListener('change', this._onMobileChange);
      }
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
      if (this._mobileHintTimer) clearTimeout(this._mobileHintTimer);
    }
  }

  const initNewsletterEnvelopes = () => {
    document.querySelectorAll('[data-newsletter-envelope-section]').forEach((el) => {
      if (el.dataset.newsletterInitialized === 'true') return;
      el.dataset.newsletterInitialized = 'true';
      el._newsletterInstance = new NewsletterEnvelope(el);
    });
  };

  initNewsletterEnvelopes();
  document.addEventListener('shopify:section:load', initNewsletterEnvelopes);
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target;
    if (section._newsletterInstance) {
      section._newsletterInstance.destroy();
      section._newsletterInstance = null;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pill-menu"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var scrollBar = document.querySelector('.pill-menu__scroll-bar');
    if (!scrollBar) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var isMobile = window.innerWidth < 750;
    var section = scrollBar.closest('.pill-menu-section');
    var style = getComputedStyle(section);

    var delay = parseInt(
      style.getPropertyValue(
        isMobile ? '--pill-enter-delay-mobile' : '--pill-enter-delay-desktop'
      )
    ) || 1000;
    var duration = parseInt(
      style.getPropertyValue(
        isMobile ? '--pill-enter-duration-mobile' : '--pill-enter-duration-desktop'
      )
    ) || 420;

    setTimeout(function () {
      scrollBar.classList.add('is-visible');

      setTimeout(function () {
        scrollBar.classList.add('is-hiding');
      }, 7000);
    }, delay + duration);
  })();

  } catch(e) { console.error(e); }
})();
})();
